export const PATIENT_REDUCER_STATE_ID = 'patient' as const;
export const PATIENTS_SEARCH_COMPONENTS = {
  filter: false,
  list: false,
};
export const ROUTE_PATIENTS = '/patients';
export const PATIENT_NAVIGATION_GROUP = 'PATIENT_GROUP';

export enum HealthcareTableIconColors {
  Default = '#000000',
  ReportedHai = '#FFC000',
  ConfirmedHai = '#FF0000',
  ColonizationHai = '#2E75B6',
}

export const TRANSLATE_HEALTHCARE_TABLE = 'patient.detail.healthcare.table.';
